<app-create-location-dialog></app-create-location-dialog>
<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="p-0 flex flex-col bg-[#FFFFFF] rounded-[16px] font-[Gilroy]" *ngIf="!successful">
            <div class="flex flex-col gap-2">
                <div class="flex w-full gap-4 justify-between items-center p-4">
                    <p *ngIf="!editLocation" class="text-primary font-semibold mobile:text-sm">{{
                        'locations.add_new' | transloco
                        }}
                    </p>
                    <p *ngIf="editLocation" class="text-primary font-semibold mobile:text-sm">{{
                        'locations.edit_location' | transloco
                        }}
                    </p>

                    <button *ngIf="editLocation" (click)="deleteLocation()"
                        title="{{ 'locations.delete_location' | transloco }}">
                        <svg width="35" height="35" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="25" cy="25" r="24" fill="#FF0000" />

                            <image href="assets/icons/delete.svg" x="12" y="12" height="25px" width="25px" />
                        </svg>
                    </button>
                </div>
                <div class="flex">
                    <div class="h-[2px] bg-primary min-w-[200px] mobile:w-full"></div>
                    <div class="flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col p-4 gap-2">
                <h3 class="text-xl font-bold">{{ 'locations.general_data' | transloco }}</h3>

                <div class="flex flex-col gap-2 px-1 h-[55vh] overflow-y-auto">
                    <!-- First row -->
                    <div class="w-full flex flex-wrap gap-2">
                        <!-- Street input -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input labelText="{{ 'shared.labels.street' | transloco }}" [inputId]="'street'"
                                [inputType]="'text'" [(inputValue)]="streetInput" [errorMessage]="streetInputError"
                                placeholder="{{ 'shared.placeholders.street' | transloco }}"></app-labeled-input>
                        </div>
                        <!-- Nr input -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input labelText="{{ 'shared.labels.street_number' | transloco }}"
                                [inputId]="'streetNumber'" [inputType]="'text'" [(inputValue)]="streetNumberInput"
                                [errorMessage]="streetNumberInputError"
                                placeholder="{{ 'shared.placeholders.street_number' | transloco }}"></app-labeled-input>
                        </div>
                        <!-- Postal Code input -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input labelText="{{ 'shared.labels.postal_code' | transloco }}"
                                [inputId]="'postalCode'" [inputType]="'text'" [(inputValue)]="postalCodeInput"
                                [errorMessage]="postalCodeInputError"
                                placeholder="{{ 'shared.placeholders.postal_code' | transloco }}"></app-labeled-input>
                        </div>
                    </div>
                    <!-- Second row -->
                    <div class="w-full flex flex-wrap gap-2">
                        <!-- City input -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input labelText="{{ 'shared.labels.city' | transloco }}" [inputId]="'city'"
                                [inputType]="'text'" [(inputValue)]="cityInput" [errorMessage]="cityInputError"
                                placeholder="{{ 'shared.placeholders.city' | transloco }}"></app-labeled-input>
                        </div>
                        <!-- Province input -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input labelText="{{ 'shared.labels.province' | transloco }}"
                                [inputId]="'province'" [inputType]="'text'" [(inputValue)]="provinceInput"
                                [errorMessage]="provinceInputError"
                                placeholder="{{ 'shared.placeholders.province' | transloco }}"></app-labeled-input>
                        </div>
                    </div>
                    <!-- Electricity -->
                    <p class="text-primary text-lg font-bold mt-2">{{ 'shared.electricity' | transloco }}</p>
                    <p *ngIf="electricityInputs.length == 0">{{ 'locations.no_electricity_invoices' | transloco}} <a
                            class="text-primary hover:underline" routerLink="/file-upload/add">{{ 'locations.click_here'
                            | transloco}}</a> {{ 'locations.to_upload_new' | transloco}}</p>
                    <div *ngFor="let pod of electricityInputs; let i = index" class="flex flex-col gap-2">
                        <p class="text-primary mt-2">POD {{ (i+1) }}</p>
                        <!-- First row -->
                        <div class="w-full flex flex-wrap gap-2">
                            <!-- Supplier input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-labeled-input labelText="{{ 'shared.labels.electricity.supplier' | transloco }}"
                                    [inputId]="'supplier'" [inputType]="'text'" [(inputValue)]="pod.supplierInput"
                                    placeholder="{{ 'shared.placeholders.electricity.supplier' | transloco }}"></app-labeled-input>
                            </div>
                            <!-- Accise input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-custom-number-input
                                    labelText="{{ 'shared.labels.electricity.excise_taxes' | transloco }}"
                                    [inputId]="'exciseTaxes'" [inputType]="'number'" [(inputValue)]="pod.exciseTaxesInput"
                                    placeholder="{{ 'shared.placeholders.electricity.excise_taxes' | transloco }}"></app-custom-number-input>
                            </div>
                            <!-- POD ID input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-labeled-input labelText="{{ 'shared.labels.electricity.pod_id' | transloco }}"
                                    [inputId]="'podId'" [inputType]="'text'" [(inputValue)]="pod.podIdInput"
                                    placeholder="{{ 'shared.placeholders.electricity.pod_id' | transloco }}"></app-labeled-input>
                            </div>
                        </div>
                        <!-- Second row -->
                        <div class="w-full flex flex-wrap gap-2">
                            <!-- VAT input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-custom-number-input labelText="{{ 'shared.labels.electricity.vat' | transloco }}"
                                    [inputId]="'vat'" [inputType]="'number'" [(inputValue)]="pod.vatInput"
                                    placeholder="{{ 'shared.placeholders.electricity.vat' | transloco }}"></app-custom-number-input>
                            </div>
                            <!-- Available Capacity input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-custom-number-input
                                    labelText="{{ 'shared.labels.electricity.available_capacity' | transloco }}"
                                    [inputId]="'availableCapacity'" [inputType]="'number'"
                                    [(inputValue)]="pod.availableCapacityInput"
                                    placeholder="{{ 'shared.placeholders.electricity.available_capacity' | transloco }}"></app-custom-number-input>
                            </div>
                            <!-- Start of Supply input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-custom-date-input
                                    labelText="{{ 'shared.labels.electricity.start_of_supply' | transloco }}"
                                    inputId="startOfSupply"
                                    placeholder="{{ 'shared.placeholders.electricity.start_of_supply' | transloco }}"
                                    [(dateValue)]="pod.startOfSupplyDate" [isDisabled]="false"
                                    dateFormat="dd/mm/yy"></app-custom-date-input>
                            </div>
                        </div>
                        <!-- Third row -->
                        <div class="w-full flex flex-wrap gap-2">
                            <!-- Tension input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-labeled-input labelText="{{ 'shared.labels.electricity.tension' | transloco }}"
                                    [inputId]="'tension'" [inputType]="'text'" [(inputValue)]="pod.tensionInput"
                                    placeholder="{{ 'shared.labels.electricity.tension' | transloco }}"></app-labeled-input>
                            </div>
                            <!-- End of Supply input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-custom-date-input
                                    labelText="{{ 'shared.labels.electricity.end_of_supply' | transloco }}"
                                    inputId="endOfSupply"
                                    placeholder="{{ 'shared.placeholders.electricity.end_of_supply' | transloco }}"
                                    [(dateValue)]="pod.endOfSupplyDate" [isDisabled]="false"
                                    dateFormat="dd/mm/yy"></app-custom-date-input>
                            </div>
                        </div>
                    </div>

                    <!-- Gas -->
                    <p class="text-primary text-lg font-bold mt-2">{{ 'shared.gas' | transloco }}</p>
                    <p *ngIf="gasInputs.length == 0">{{ 'locations.no_gas_invoices' | transloco}} <a
                            class="text-primary hover:underline" routerLink="/file-upload/add">{{ 'locations.click_here'
                            | transloco}}</a> {{ 'locations.to_upload_new' | transloco}}</p>
                    <div *ngFor="let pdr of gasInputs; let i = index" class="flex flex-col gap-2">
                        <p class="text-primary mt-2">PDR {{ (i+1) }}</p>
                        <!-- First row -->
                        <div class="w-full flex flex-wrap gap-2">
                            <!-- Supplier input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-labeled-input labelText="{{ 'shared.labels.gas.supplier' | transloco }}"
                                    [inputId]="'gasSupplier'" [inputType]="'text'" [(inputValue)]="pdr.gasSupplierInput"
                                    placeholder="{{ 'shared.placeholders.gas.supplier' | transloco }}"></app-labeled-input>
                            </div>
                            <!-- VAT input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-custom-number-input labelText="{{ 'shared.labels.gas.vat' | transloco }}"
                                    [inputId]="'gasVat'" [inputType]="'number'" [(inputValue)]="pdr.gasVatInput"
                                    placeholder="{{ 'shared.placeholders.gas.vat' | transloco }}"></app-custom-number-input>
                            </div>
                            <!-- PDR ID input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-labeled-input labelText="{{ 'shared.labels.gas.pdr_id' | transloco }}"
                                    [inputId]="'pdrId'" [inputType]="'text'" [(inputValue)]="pdr.pdrIdInput"
                                    placeholder="{{ 'shared.placeholders.gas.pdr_id' | transloco }}"></app-labeled-input>
                            </div>
                        </div>
                        <!-- Second row -->
                        <div class="w-full flex flex-wrap gap-2 mb-2">
                            <!-- Start of Supply input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-custom-date-input labelText="{{ 'shared.labels.gas.start_of_supply' | transloco }}"
                                    inputId="gasStartOfSupply"
                                    placeholder="{{ 'shared.placeholders.gas.start_of_supply' | transloco }}"
                                    [(dateValue)]="pdr.gasStartOfSupplyDate" [isDisabled]="false" dateFormat="dd/mm/yy">
                                </app-custom-date-input>

                            </div>
                            <!-- REMI input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-labeled-input labelText="{{ 'shared.labels.gas.remi' | transloco }}"
                                    [inputId]="'remi'" [inputType]="'text'" [(inputValue)]="pdr.remiInput"
                                    placeholder="{{ 'shared.placeholders.gas.remi' | transloco }}"></app-labeled-input>
                            </div>
                            <!-- End of Supply input -->
                            <div class="flex-[1] self-center min-w-[250px]">
                                <app-custom-date-input labelText="{{ 'shared.labels.gas.end_of_supply' | transloco }}"
                                    inputId="gasEndOfSupply"
                                    placeholder="{{ 'shared.placeholders.gas.end_of_supply' | transloco }}"
                                    [(dateValue)]="pdr.gasEndOfSupplyDate" [isDisabled]="false" dateFormat="dd/mm/yy">
                                </app-custom-date-input>

                            </div>
                        </div>
                    </div>
                </div>
                <p class="text-base text-neutral-500">{{ 'locations.instructions.please' | transloco }}<span
                        class="text-black font-bold">{{ 'locations.instructions.add_missing' | transloco }}</span>{{
                    'locations.instructions.data_and' | transloco }}<span class="text-black font-bold">{{
                        'locations.instructions.confirm' | transloco }}</span><span *ngIf="!editLocation">{{
                        'locations.instructions.pre_filled_information' | transloco }}</span><span
                        *ngIf="editLocation">{{
                        'locations.instructions.pre_filled_information_edit' | transloco }}</span></p>
                <div *ngIf="dialogErrorMessage" class="flex items-center text-error mt-2 text-sm">
                    <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
                        class="w-5 h-5" />
                    <p class="ml-1">{{ dialogErrorMessage }}</p>
                </div>
                <div class="flex w-full gap-4">
                    <div class="flex-[1] h-[45px]">
                        <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" (buttonClick)="closeModal()"
                            backgroundColor="bg-[#FFFFFF]" textColor="text-secondary" borderColor="border-secondary"
                            hoverBackgroundColor="hover:bg-secondary"
                            hoverBorderColor="hover:border-secondary"></app-custom-button>
                    </div>
                    <div class="flex-[1] h-[45px]">
                        <app-custom-button *ngIf="!editLocation" buttonText="{{ 'shared.confirm' | transloco }}"
                            (buttonClick)="confirmButtonClick()" backgroundColor="bg-primary" textColor="text-white"
                            borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200"
                            [isDisabled]="confirmClicked"></app-custom-button>

                        <app-custom-button *ngIf="editLocation" buttonText="{{ 'shared.save' | transloco }}"
                            (buttonClick)="saveButtonClick()" backgroundColor="bg-primary" textColor="text-white"
                            borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200"
                            [isDisabled]="confirmClicked"></app-custom-button>
                    </div>
                </div>

            </div>
        </div>
        <div class="p-0 flex flex-col bg-[#FFFFFF] rounded-[16px]" *ngIf="successful">
            <div class="flex w-full justify-center items-center mt-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="91" height="91" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M10.0001 18.3337C14.5834 18.3337 18.3334 14.5837 18.3334 10.0003C18.3334 5.41699 14.5834 1.66699 10.0001 1.66699C5.41675 1.66699 1.66675 5.41699 1.66675 10.0003C1.66675 14.5837 5.41675 18.3337 10.0001 18.3337Z"
                        fill="#80A7A5" stroke="#80A7A5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.45837 9.99993L8.81671 12.3583L13.5417 7.6416" stroke="white" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </div>

            <div class="flex flex-col gap-4 items-center justify-center mt-8 mobile:text-center">
                <h3 *ngIf="!editLocation" class="text-3xl font-bold">{{ 'locations.location_added' | transloco }}</h3>
                <h3 *ngIf="editLocation" class="text-3xl font-bold">{{ 'locations.location_edited' | transloco }}</h3>
                <p *ngIf="!editLocation" class="text-base text-neutral-500">{{ 'locations.start_analyse' | transloco }}
                </p>
            </div>

            <div class="flex w-full justify-center items-center mb-6 mt-8">
                <div class="w-[80%] h-[60px]">
                    <app-custom-button buttonText="{{ 'shared.close' | transloco }}" (buttonClick)="closeModal()"
                        backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                        hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>
                </div>
            </div>
        </div>
    </ng-template>
</p-dialog>